import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxGdlModalModule } from '@krysgroup/ngx-modal';
import { NgxGdlNotificationV2Component } from '@krysgroup/ngx-notification';
import { TranslateService } from '@ngx-translate/core';

const supportedLanguages = ['fr'];
const defaultLanguageIfUnknown = supportedLanguages[0];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    NgxGdlModalModule, NgxGdlNotificationV2Component, RouterOutlet
  ]
})
export class AppComponent {
  constructor() {
    const translateService = inject(TranslateService);

    translateService.addLangs(supportedLanguages);
    let currentLanguage = translateService.getBrowserLang() ?? defaultLanguageIfUnknown;
    if (!supportedLanguages.some((language: string) => language === currentLanguage)) {
      currentLanguage = defaultLanguageIfUnknown;
    }
    translateService.setDefaultLang(currentLanguage);
    translateService.use(currentLanguage);
  }
}
